import React, { Component } from "react";

class Loader extends Component {
  render() {
    var size = "40";
    if (this.props.size !== undefined) {
      size = this.props.size;
    }
    return (
      <svg className="icon loader" width={size} height={size}>
        <use href="#loader"></use>
      </svg>
    );
  }
}

export default Loader;
